import { render, staticRenderFns } from "./sys-referee-type-manage.vue?vue&type=template&id=d97bc7e8&scoped=true"
import script from "./sys-referee-type-manage.vue?vue&type=script&lang=js"
export * from "./sys-referee-type-manage.vue?vue&type=script&lang=js"
import style0 from "./sys-referee-type-manage.vue?vue&type=style&index=0&id=d97bc7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97bc7e8",
  null
  
)

export default component.exports